import App from './AppObelisk.svelte';

const app = new App({
	target: document.body,
});

export default app;